import { getPricingApiConfig } from '../config/actions';
import { getProductTypeUrlParameter } from './get-product-type-url-parameter';
import { getProductTypeUrlSuffix } from './get-product-type-url-suffix';
/**
 * @internal
 */
export var getFetchPricesUrlGet = function (entityIds, productType) {
    if (productType === void 0) { productType = "f" /* Family */; }
    var _a = getPricingApiConfig(), baseUrl = _a.baseUrl, marketLocale = _a.marketLocale;
    var suffix = getProductTypeUrlSuffix(productType);
    var idUrlParameter = getProductTypeUrlParameter(productType);
    var idUrlComponent = idUrlParameter + "=" + entityIds.join("&" + idUrlParameter + "=");
    return baseUrl + "/v1/" + suffix + "?" + idUrlComponent + "&marketLocale=" + marketLocale;
};
